export default __webpack_public_path__ + "static/media/test-principles.640fc499.svg";